import { UserRole } from 'globals/types';
import { InviteNewUserSingleRowProps } from 'ui-elements/forms/FsInviteNewUserRepetitiveForm/InviteNewUserSingleRow/InviteNewUserSingleRow';
import { FsInviteNewUserRepetitiveFormProps } from 'ui-elements/forms/FsInviteNewUserRepetitiveForm/FsInviteNewUserRepetitiveForm';

const inviteNewUserSingleRowProps: InviteNewUserSingleRowProps[] = [
  {
    email: '',
    role: UserRole.USER,
  },
];

export const fsInviteNewUserRepetitiveFormProps: FsInviteNewUserRepetitiveFormProps = {
  rows: inviteNewUserSingleRowProps,
};
